import appConfig from 'configs/app.config'

const USER_PHOTO_PATH = 'uploads/user_photos/'
const IMAGE_FILE_PATTERN = /\.(jpe?g|png|gif|webp|bmp)(\?.*)?(#.*)?$/i

export const normalizeUserPhotoUrl = (value) => {
    if (!value) return ''

    const src = String(value).trim()
    if (!src) return ''

    if (/^https?:\/\/app\.sar24\.com\/[^/]+\.(jpe?g|png|gif|webp|bmp)(\?.*)?(#.*)?$/i.test(src)) {
        const fileName = src.split('/').pop()
        return `${appConfig.APIURL}${USER_PHOTO_PATH}${fileName}`
    }

    if (/^(data:|blob:|https?:\/\/|\/)/i.test(src)) {
        return src
    }

    if (src.startsWith(USER_PHOTO_PATH)) {
        return `${appConfig.APIURL}${src}`
    }

    if (!src.includes('/') && IMAGE_FILE_PATTERN.test(src)) {
        return `${appConfig.APIURL}${USER_PHOTO_PATH}${src}`
    }

    return src
}

export default normalizeUserPhotoUrl
